import { formSteps } from '../constants';
import { Step } from '../types';

export default function findActiveStep(activeStepIndex: number) {
  const keys: any = Object.keys(formSteps);
  const { name }: Step = formSteps[keys[activeStepIndex]];

  return name;
}
